import React from "react";
import { useIntl } from "react-intl";
import { PeekBox, PeekTooltip, useTheme } from "@piiqtechnologies/ui-components";
import { WHISKER_EDGE_THRESHOLD } from "./constants";
import messages from "./messages.i18n";
import { focusRingSx } from "./whiskerChartUtils";
export const WhiskerYouMarker = ({ userPct, yourRank, totalCompetitors }) => {
    const intl = useIntl();
    const theme = useTheme();
    // Edge detection: shift bubble + arrow so the "You" pill doesn't overflow the chart bounds
    const nearRight = userPct > 100 - WHISKER_EDGE_THRESHOLD;
    const nearLeft = userPct < WHISKER_EDGE_THRESHOLD;
    const bubbleTransform = nearRight ? "translateX(-85%)" : nearLeft ? "translateX(-15%)" : "translateX(-50%)";
    const arrowLeft = nearRight ? "85%" : nearLeft ? "15%" : "50%";
    const tooltipPlacement = nearRight ? "top-end" : nearLeft ? "top-start" : "top";
    return (React.createElement(PeekTooltip, { title: intl.formatMessage(messages.tooltipYou, { rank: yourRank, total: totalCompetitors }), placement: tooltipPlacement },
        React.createElement(PeekBox, { tabIndex: 0, sx: Object.assign(Object.assign({}, focusRingSx(theme)), { position: "absolute", bottom: "100%", mb: 1, left: `${userPct}%`, transform: bubbleTransform, bgcolor: "white", border: 2, borderColor: "secondary.main", borderRadius: 3, px: 2.5, py: 1, fontWeight: "fontWeightMedium", color: "text.primary", fontSize: 14, whiteSpace: "nowrap", zIndex: 10, "&::after": {
                    content: '""',
                    position: "absolute",
                    bottom: -12,
                    left: arrowLeft,
                    transform: "translateX(-50%)",
                    width: 0,
                    height: 0,
                    borderLeft: "12px solid transparent",
                    borderRight: "12px solid transparent",
                    borderTop: `12px solid ${theme.palette.secondary.main}`,
                } }) },
            intl.formatMessage(messages.youRankLabel, { rank: yourRank }),
            React.createElement(PeekBox, { sx: {
                    position: "absolute",
                    bottom: -10,
                    left: arrowLeft,
                    transform: "translateX(-50%)",
                    width: 0,
                    height: 0,
                    borderLeft: "10px solid transparent",
                    borderRight: "10px solid transparent",
                    borderTop: "10px solid white",
                } }))));
};
export default WhiskerYouMarker;
